import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/acehighway/manifest'
import pathMap from 'src/paths/pathMap'

class AceHighwayManifestRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACE_HIGHWAY_MANIFEST_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACE_HIGHWAY_MANIFEST_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACE_HIGHWAY_MANIFEST_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACE_HIGHWAY_MANIFEST_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AceHighwayManifestRoute
